import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS } from '../../constants'

export const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    ['& > div']: {
      marginBottom: '4%',
      width: '48%',
      height: 0,
      paddingBottom: '47%',
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      flexWrap: 'nowrap',
      overflowX: 'auto',
      scroll: 'hidden',
      width: '100%',
      ['& > div']: {
        minWidth: '10rem',
      },
    },
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      flexWrap: 'nowrap',
      overflowX: 'auto',
      scroll: 'hidden',
      width: '100%',
      ['& > div']: {
        minWidth: '10rem',
      },
    },
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      flexWrap: 'nowrap',
      overflowX: 'auto',
      scroll: 'hidden',
      width: '100%',
      ['& > div']: {
        minWidth: '10rem',
      },
    },
  },

  spaceCards: {
    justifyContent: 'space-between',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      justifyContent: 'flex-start',
      minWidth: '10rem',
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      padding: '20px',
      minWidth: '10rem',
    },
  },

  centerCards: {
    justifyContent: 'center',
  },

  spinnerContainer: {
    minHeight: 280,
  },

  [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
    container: {
      ['& > div']: {
        marginLeft: '1.6%',
        marginBottom: '2%',
        width: '23%',
        height: 0,
        paddingBottom: '23%',
      },
    },
  },
}))
